import React from "react";
import { withRouter } from "react-router-dom";

import styles from "./SidebarVideoSquirrelLogo.module.scss";
import logo from "../../assets/whiteVideoSquirrelLogo.png";

function SidebarVideoSquirrelLogo({ history, collapsed }) {
  return collapsed ? (
    <div className={styles.logoWrapper}>
      <div className={styles.logo} onClick={() => history.push("/")}>
        <img src={logo} alt="Video Squirrel" />
      </div>
    </div>
  ) : (
    <div className={styles.logoWrapper}>
      <div className={styles.logo} onClick={() => history.push("/")}>
        <img src={logo} alt="Video Squirrel" />
        <span>Video Squirrel</span>
      </div>
    </div>
  );
}

export default withRouter(SidebarVideoSquirrelLogo);
